import * as React from "react";
import { Route, Switch } from "react-router-dom";
import Suggestions from "../views/suggestions";
import ThemeList from "../views/themes";
import SubthemeList from "../views/themes/subthemes";
import Experts from "../views/experts";
import UserList from "../views/users";
import SuggestionView from "../views/suggestions/view";
import NotFound from "../views/NotFound";
import Login from "../views/Login";
import ThemesToOffer from "../views/themestooffer";
import QuizList from "../views/quizzes";
import QuizEdit from "../views/quizzes/edit";
import QuizResults from "../views/quizzes/results";
import NewsList from "../views/news";
import NewsEdit from "../views/news/edit";
import SuggestionsUpdates from "../views/suggestionsupdates";
import SuggestionUpdateView from "../views/suggestionsupdates/view";
var publicPath = "/";
export var routeCodes = {
    DASHBOARD: publicPath,
    USER_LIST: publicPath + "users/",
    EXPERT_LIST: publicPath + "experts/",
    THEME_LIST: publicPath + "themes/",
    THEME_TO_OFFER: publicPath + "themes-to-offer/",
    SUBTHEME_LIST: publicPath + "themes/:id/subthemes/",
    SUGGESTION_LIST: publicPath + "suggestions/",
    SUGGESTION_UPDATES_LIST: publicPath + "suggestions-update/",
    SUGGESTION_ONE: publicPath + "suggestions/:id",
    SUGGESTION_UPDATES_ONE: publicPath + "suggestions-update/:id",
    QUIZ_LIST: publicPath + "quizzes/",
    QUIZ_ONE: publicPath + "quizzes/:id",
    QUIZ_RESULTS: publicPath + "quizzes/:id/results/",
    NEWS_LIST: publicPath + "news/",
    NEWS_ONE: publicPath + "news/:id",
    LOGIN: publicPath + "login",
};
export default (function () { return (React.createElement(React.Fragment, null,
    React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: routeCodes.DASHBOARD, component: Suggestions }),
        React.createElement(Route, { exact: true, path: routeCodes.SUGGESTION_LIST, component: Suggestions }),
        React.createElement(Route, { exact: true, path: routeCodes.SUGGESTION_UPDATES_LIST, component: SuggestionsUpdates }),
        React.createElement(Route, { exact: true, path: routeCodes.QUIZ_LIST, component: QuizList }),
        React.createElement(Route, { exact: true, path: routeCodes.THEME_LIST, component: ThemeList }),
        React.createElement(Route, { exact: true, path: routeCodes.THEME_TO_OFFER, component: ThemesToOffer }),
        React.createElement(Route, { exact: true, path: routeCodes.SUBTHEME_LIST, component: SubthemeList }),
        React.createElement(Route, { exact: true, path: routeCodes.EXPERT_LIST, component: Experts }),
        React.createElement(Route, { exact: true, path: routeCodes.USER_LIST, component: UserList }),
        React.createElement(Route, { exact: true, path: routeCodes.SUGGESTION_ONE, component: SuggestionView }),
        React.createElement(Route, { exact: true, path: routeCodes.SUGGESTION_UPDATES_ONE, component: SuggestionUpdateView }),
        React.createElement(Route, { exact: true, path: routeCodes.QUIZ_ONE, component: QuizEdit }),
        React.createElement(Route, { exact: true, path: routeCodes.LOGIN, component: Login }),
        React.createElement(Route, { exact: true, path: routeCodes.QUIZ_RESULTS, component: QuizResults }),
        React.createElement(Route, { exact: true, path: routeCodes.NEWS_LIST, component: NewsList }),
        React.createElement(Route, { exact: true, path: routeCodes.NEWS_ONE, component: NewsEdit }),
        React.createElement(Route, { path: "*", component: NotFound })))); });



//////////////////
// WEBPACK FOOTER
// ./src/config/routes.tsx
// module id = 151
// module chunks = 0